var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMintsbt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 59,
    viewBox: "0 0 107 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2324_3605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 5.26773L4.60887 22.2521C0.310876 26.2766 0.310876 32.8015 4.60887 36.826L22.7477 53.8104C27.0457 57.8348 34.0142 57.8348 38.3121 53.8104L56.451 36.826C60.749 32.8015 60.749 26.2766 56.451 22.2521L38.3121 5.26774C34.0142 1.24328 27.0457 1.24328 22.7477 5.26773Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7477 5.26773L4.60887 22.2521C0.310876 26.2766 0.310876 32.8015 4.60887 36.826L22.7477 53.8104C27.0457 57.8348 34.0142 57.8348 38.3121 53.8104L56.451 36.826C60.749 32.8015 60.749 26.2766 56.451 22.2521L38.3121 5.26774C34.0142 1.24328 27.0457 1.24328 22.7477 5.26773Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5386 22.6176V36.488C20.5386 37.8247 21.6958 38.9082 23.1232 38.9082H37.9365C39.364 38.9082 40.5212 37.8247 40.5212 36.488V22.6176C40.5212 21.2809 39.364 20.1974 37.9365 20.1974H23.1232C21.6958 20.1974 20.5386 21.2809 20.5386 22.6176Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6372 16.8921C55.5286 8.25238 65.2559 2.37109 76.4284 2.37109C92.5479 2.37109 105.61 14.6021 105.61 29.6956C105.61 44.7892 92.5479 57.0202 76.4284 57.0202C65.2559 57.0202 55.5286 51.1389 50.6372 42.4991",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6787 34.666C81.7593 34.666 85.8779 30.8095 85.8779 26.0522C85.8779 21.295 81.7593 17.4385 76.6787 17.4385C71.5981 17.4385 67.4795 21.295 67.4795 26.0522C67.4795 30.8095 71.5981 34.666 76.6787 34.666Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9075 53.4029C88.9075 46.9491 83.3213 41.6924 76.401 41.6924C69.4808 41.6924 63.8945 46.9231 63.8945 53.4029",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2324_3605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 57.3555,
    fill: "white",
    transform: "translate(0 0.96582)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintsbt);
export default __webpack_public_path__ + "static/media/mintsbt.a1dd84043b53744ccadf5a8ababf30a7.svg";
export { ForwardRef as ReactComponent };